import React from 'react';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { AttachFile as AttachFileIcon, Close as CloseIcon } from '@mui/icons-material';
import { EMAIL_ATTACHMENT_ACCEPT } from '../utils/emailCampaigns';

const EmailAttachmentField = ({ attachment, onChange }) => (
  <Box sx={{ my: 2 }}>
    <Button component="label" variant="outlined" startIcon={<AttachFileIcon />}>
      {attachment ? 'Replace attachment' : 'Attach file'}
      <input
        hidden
        type="file"
        accept={EMAIL_ATTACHMENT_ACCEPT}
        onChange={(event) => onChange(event.target.files?.[0] || null)}
      />
    </Button>
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.75 }}>
      One PDF, Word, Excel, image, or text file up to 5 MB.
    </Typography>
    {attachment && (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1 }}>
        <Typography variant="body2">{attachment.name}</Typography>
        <IconButton size="small" aria-label="Remove attachment" onClick={() => onChange(null)}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
    )}
  </Box>
);

export default EmailAttachmentField;
